import $ from 'jquery';
import React, { useState, useEffect } from 'react';
import DropdownButton from '../bootstrap4/DropdownButton';
import Input from '../bootstrap4/Input'

function Threshold(props) {

    const [threshold, setThreshold] = useState(props.threshold);
    //console.log('Threshold before loading ..', this.thresholdCopy);

    let defaultOptions = {
        notifyOnOptions: [
            { value: 'always', label: 'Always', type: 'notify_on', default: true },
            { value: 'work', label: 'Work Hours', type: 'notify_on' },
            { value: 'offwork', label: 'Off Work Hours', type: 'notify_on' }
        ],
        notifyOnWorkFreqOptions: [
            { value: '180', label: '3 hours (default)', type: 'alert_timeout', default: true }
        ],
        notifyOffWorkFreqOptions: [
            { value: '10', label: '10 minutes', type: 'alert_timeout_off' },
            { value: '30', label: '30 minutes', type: 'alert_timeout_off' },
            { value: '60', label: '1 hour', type: 'alert_timeout_off' },
            { value: '180', label: '3 hours (default)', type: 'alert_timeout_off', default: true }
        ],
        notifyOffWorkFreqVehicleOptions: [
            { value: '10', label: '10 minutes', type: 'alert_timeout' },
            { value: '30', label: '30 minutes', type: 'alert_timeout' },
            { value: '60', label: '1 hour', type: 'alert_timeout' },
            { value: '180', label: '3 hours (default)', type: 'alert_timeout', default: true }
        ]
    };

    if (props.threshold.sensor_id === 'battbackup' || props.threshold.sensor_id === 'flow')
        defaultOptions.notifyOnOptions = [{ value: 'always', label: 'Always', type: 'notify_on', default: true }];

    let labels = {
        'motion': 'People Motion Detection',
        'vmotion_ahours': 'Vehicle Motion Detection',
        'temperature': 'Air Temperature Change',
        'humidity': 'Air Humidity Change',
        'co2': 'CO2 (Carbon Dioxide) Level Change',
        'co': 'CO (Carbon Monoxide) Level Change',
        'voc': 'Air Quality (Volatile Organic Compounds) Change',
        'weather_wind': 'Wind Speed',
        'weather_gust': 'Wind Gusts Speed',
        'weather_temperature': 'Temperature Change',
        'weather_humidity': 'Humidity Change',
        'weather_precip': 'Precipitation Accumulation',
        'leak': 'Water Leak Detection',
        'flow': 'Water Flow Detection',
        'battbackup': 'Battery Backup'
    }

    let thresholdOptions = {
        'co': {
            'alert_up': [
                { label: 'First Level Risk - 20 ppm', value: '20', type: 'alert_up' },
                { label: 'NIOSH Recommended - 35 ppm', value: '35', type: 'alert_up', default: true },
                { label: 'OSHA Recommended - 50 ppm', value: '50', type: 'alert_up' },
                { label: 'First Alarm Level - 70 ppm', value: '70', type: 'alert_up' }
            ],
            'units': 'ppm'
        },
        'co2': {
            'alert_up': [
                { label: 'Complaints of drowsiness - 1000 ppm', value: '1000', type: 'alert_up' },
                { label: 'Headaches, sleepiness - 2000 ppm', value: '2000', type: 'alert_up' },
                { label: 'Workplace exposure limit - 5000 ppm', value: '5000', type: 'alert_up' }
            ],
            'units': 'ppm'
        },
        'voc': {
            'alert_up': [
                { label: 'Health Complaints - 1000 ppb', value: '1000', type: 'alert_up' },
                { label: 'Serious health effects - 10000 ppb', value: '10000', type: 'alert_up' }
            ],
            'units': 'ppb'
        },
        'weather_wind': {
            'units': 'mph'
        },
        'weather_gust': {
            'alert_up': [
                { value: '20', label: '20mph - OSHA Brisk gale', type: 'alert_up' },
                { value: '30', label: '30mph - OSHA High Wind', type: 'alert_up' },
                { value: '40', label: '40mph - OSHA Very High Wind', type: 'alert_up' }
            ],
            'units': 'mph'
        },
        'weather_precip': {
            'units': 'inch/hour'
        },
        'leak': {
            'units': ' '
        },
        'flow': {
            'units': 'Gallons'
        },
        'battbackup': {
            'units': ' '
        },
    };


    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);

    useEffect(() => {
        isThresholdDataChanged();
    }, [threshold]);

    const addOrRemoved = (e) => {
        let targetEl = $(e.target);
        let isAdd = $(targetEl).find('.fa-plus');
        $(targetEl).html(isAdd ? <i className="fa fa-plus-circle" /> : <i className="fa fa-minus-circle" />);
        let threshold1 = { ...threshold };
        //console.log('Threshold Default : ', threshold.default);
        if (threshold1.default)
            threshold1.default = !threshold1.default;
        else
            threshold1.default = true;
        //console.log('Thresold Default After : ', threshold.default);

        //console.log('Thresold.jsx : ' + JSON.stringify(threshold));
        props.addOrRemove(threshold1);
    }

    // const updateTooltip = (el, newTitle) => {
    //     $(el).attr('title', newTitle);
    //     let tooltipId = $(el).attr('aria-describedby');
    //     $('#' + tooltipId).find('.tooltip-inner').text(newTitle);
    //     $(el).trigger('blur');
    // }

    const handleSelectOnChange = (obj) => {
        var threshold1 = { ...threshold };
        var jsonKeysHierarchy = obj.type.split('.');
        var key = threshold1;
        for (var i = 0; i < jsonKeysHierarchy.length - 1; i++) {
            if (!key[jsonKeysHierarchy[i]])
                key[jsonKeysHierarchy[i]] = {};
            key = key[jsonKeysHierarchy[i]];
        }
        key[jsonKeysHierarchy[jsonKeysHierarchy.length - 1]] = obj.type === 'alert_timeout' ? parseInt(obj.value) : obj.value;
        delete threshold1.inputValidation;
        setThreshold(threshold1);
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        var threshold1 = { ...threshold };
        threshold1[name] = value;
        threshold1["fieldName"] = labels[threshold1.sensor_id];
        if (!target.isvalidtext) {
            threshold1["inputValidation"] = {
                isvalidtext: target.isvalidtext,
                invaliderrormsg: target.invaliderrormsg,
                fieldName: labels[threshold.sensor_id],
                fieldType: name
            }

        }
        else if (threshold1.inputValidation) {
            if (threshold1.inputValidation.fieldType === name) {
                delete threshold1.inputValidation;
            }
        }
        setThreshold(threshold1);
    }

    const isThresholdDataChanged = () => {
        // console.log('Threshold: ', this.state.threshold);
        props.onChange({ ...threshold });
    }

    const handleCheckBoxChange = (event) => {
        var att = event.target.getAttribute('for');
        var threshold1 = { ...threshold };

        var jsonKeysHierarchy = att.split('.');
        var key = threshold1;
        for (var i = 0; i < jsonKeysHierarchy.length - 1; i++) {
            if (!key[jsonKeysHierarchy[i]])
                key[jsonKeysHierarchy[i]] = {};
            key = key[jsonKeysHierarchy[i]];
        }
        key[jsonKeysHierarchy[jsonKeysHierarchy.length - 1]] = !key[jsonKeysHierarchy[jsonKeysHierarchy.length - 1]];
        ;
        setThreshold(threshold1);
    }


    let isNotifyMe = threshold.notify_me;
    let isNotifyOff = threshold.notify_me_off;
    let notifyDropDownCSS = 'btn btn-sm btn-white w-100-perc dropdown-toggle  p-1 text-dark';
    let notifyOffWorkDropDownCSS = 'btn btn-sm dropdown-toggle  p-1 text-dark';
    const notifyOnDropDown = (
        <DropdownButton
            className={notifyOffWorkDropDownCSS}
            onOptionClick={handleSelectOnChange}
            default={' -- Choose -- '}
            selected={threshold.notify_on}
            opts={defaultOptions.notifyOnOptions}
            field_attr='value'
            value_attr='label' />
    );

    const notifyOffVehicleDropDown = (
        <DropdownButton
            className={notifyOffWorkDropDownCSS}
            onOptionClick={handleSelectOnChange}
            default={' -- Choose -- '}
            selected={threshold.alert_timeout + ''}
            opts={defaultOptions.notifyOffWorkFreqVehicleOptions}
            field_attr='value'
            value_attr='label' />
    );

    const notifyOnWorkFreqDropDown = (
        <DropdownButton
            className={notifyDropDownCSS}
            onOptionClick={handleSelectOnChange}
            default={' -- Choose -- '}
            selected={threshold.alert_timeout + ''}
            opts={defaultOptions.notifyOnWorkFreqOptions}
            field_attr='value'
            value_attr='label' />
    );

    const notifyOffWorkFreqDropDown = (
        <DropdownButton
            className={notifyOffWorkDropDownCSS}
            onOptionClick={handleSelectOnChange}
            default={' -- Choose -- '}
            selected={threshold.alert_timeout_off + ''}
            opts={defaultOptions.notifyOffWorkFreqOptions}
            field_attr='value'
            value_attr='label' />
    );

    const checkboxClassName = threshold.notify_me ? 'fa text-primary fa-lg fa-check-square cursor-pointer' : 'far text-primary fa-lg fa-square cursor-pointer';
    const checkboxClassNameOnWork = threshold.notify_me ? 'fa text-primary fa-lg fa-check-square cursor-pointer' : 'far text-primary fa-lg fa-square cursor-pointer';
    const checkboxClassNameOffWork = threshold.notify_me_off ? 'fa text-primary fa-lg fa-check-square cursor-pointer' : 'far text-primary fa-lg fa-square cursor-pointer';
    const showCardBody = (threshold.default === true);
    // console.log(threshold);

    return (
        <div className='card border border-0 px-2 mb-2'>
            <div className='card-header p-0'>
                <div className='card-title pl-2 mb-0 bg-light p-1 text-primary text-capitalize'>
                    {labels[threshold.sensor_id]}
                    {/* {(this.state.threshold.sensor_id === 'co' || this.state.threshold.sensor_id === 'co2' || this.state.threshold.sensor_id === 'voc') ? <span className='text-danger ml-2'>(Not Activated)</span> : ''} */}
                    <span className="pull-right">
                        {threshold.default && <span className='badge bg-warning font-size-12 text-dark mr-3'>Not Activated</span>}
                        <span onClick={(e) => addOrRemoved(e)}>{threshold.default ? <i className="fa fa-lg cursor-pointer fa-plus-circle" /> : <i className="fa fa-lg cursor-pointer text-danger fa-minus-circle" />}</span>
                    </span>
                </div>
            </div>

            <div className={showCardBody ? 'collapse' : 'collapse show'} aria-labelledby='headingOne'>
                <div className='card-body bg-white border-light'>
                    {
                        // Motion Sensor
                        (threshold.sensor_id === 'motion') &&
                        <div >
                            <div className='row pb-2'>
                                <div className='col'>
                                    <i htmlFor='notify_me' className={checkboxClassNameOnWork} value={isNotifyMe} onClick={handleCheckBoxChange}></i>
                                    &nbsp; Notify me during Work Hours.
                                </div>
                            </div>
                            <div className='row pb-3 hide'>
                                <div className='col'>
                                    {notifyOnWorkFreqDropDown}
                                </div>
                            </div>
                            <div className='row pb-2 mt-2'>
                                <div className='col'>
                                    <i htmlFor='notify_me_off' className={checkboxClassNameOffWork} value={isNotifyOff} onClick={handleCheckBoxChange}></i>
                                    &nbsp; Notify Me Every {notifyOffWorkFreqDropDown} during Off-Work Hours
                                </div>
                            </div>
                        </div>
                    }

                    {
                        // Motion Sensor
                        (threshold.sensor_id === 'vmotion_ahours') &&
                        <div >
                            <div className='row pb-2 mt-2'>
                                <div className='col'>
                                    <i htmlFor='notify_me' className={checkboxClassNameOnWork} value={isNotifyMe} onClick={handleCheckBoxChange}></i>
                                    &nbsp; Notify Me Every {notifyOffVehicleDropDown} during Off-Work Hours
                                </div>
                            </div>
                        </div>
                    }

                    {
                        // Temperature, Humidity sensor
                        (['temperature', 'humidity', 'weather_humidity', 'weather_temperature'].indexOf(threshold.sensor_id) !== -1) &&
                        <div >
                            <div className='row pb-4'>
                                <div className='col-md-6'>
                                    <span className='d-inline'>If drops below </span>
                                    <Input onChange={handleInputChange} name='alert_down' autoComplete="off" type='decimalNumber' value={threshold.alert_down === "noop" ? "" : threshold.alert_down} className='form-control d-inline w-75 text-center' fieldname={labels[threshold.sensor_id]} /> {['humidity', 'weather_humidity'].indexOf(threshold.sensor_id) !== -1 ? '%' : 'F'}
                                </div>

                                <div className='col-md-6'>
                                    <span className='d-inline'> or rises above </span>
                                    <Input onChange={handleInputChange} name='alert_up' autoComplete="off" type='decimalNumber' value={threshold.alert_up === "noop" ? "" : threshold.alert_up} className='form-control d-inline w-75 text-center' fieldname={labels[threshold.sensor_id]} /> {['humidity', 'weather_humidity'].indexOf(threshold.sensor_id) !== -1 ? '%' : 'F'}
                                </div>
                            </div>
                            <div className='row pb-2 '>
                                <div className='col'>
                                    <i htmlFor='notify_me' className={checkboxClassName} value={isNotifyMe} onClick={handleCheckBoxChange}></i>
                                    &nbsp; Notify me only during : {notifyOnDropDown}
                                </div>
                            </div>
                        </div>
                    }

                    {
                        // other than temp, humidity
                        (['weather_precip', 'windspeed', 'weather_wind', 'weather_gust', 'co', 'co2', 'voc'].indexOf(threshold.sensor_id) !== -1) &&
                        <div>
                            {
                                thresholdOptions[threshold.sensor_id]['alert_up'] ?
                                    <React.Fragment>
                                        <div className='row pb-4'>
                                            <div className='col-md-6 pr-0'>
                                                <span className='d-inline'>If exceeds </span>
                                                <DropdownButton
                                                    maxChars="18"
                                                    className='btn btn-sm d-inline dropdown-toggle dropdown-toggle-split btn-radius-0 p-1 text-dark'
                                                    onOptionClick={handleSelectOnChange}
                                                    default={' -- Choose -- '}
                                                    selected={threshold.alert_up}
                                                    opts={thresholdOptions[threshold.sensor_id]['alert_up']}
                                                    field_attr='value'
                                                    value_attr='label' />
                                            </div>
                                            <div className='col-md-6'>
                                                <span className='d-inline'>or Custom </span>
                                                <Input onChange={handleInputChange} name='alert_up' autoComplete="off" type='wholeDecimalNumber' value={threshold.alert_up} className='form-control d-inline w-75 text-center px-0' fieldname={labels[threshold.sensor_id]} /> {thresholdOptions[threshold.sensor_id]['units']}
                                            </div>
                                        </div>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <div className='row pb-4'>
                                            <div className='col-12'>
                                                <span className='d-inline'>If exceeds </span>
                                                <Input onChange={handleInputChange} name='alert_up' autoComplete="off" type='wholeDecimalNumber' value={threshold.alert_up} className='form-control d-inline w-75 text-center' fieldname={labels[threshold.sensor_id]} /> {thresholdOptions[threshold.sensor_id]['units']}
                                            </div>
                                        </div>
                                    </React.Fragment>
                            }
                            <div className='row pb-2'>
                                <div className='col'>
                                    <i htmlFor='notify_me' className={checkboxClassName} value={isNotifyMe} onClick={handleCheckBoxChange}></i>
                                    &nbsp; Notify me only during : {notifyOnDropDown}
                                </div>
                            </div>
                        </div>
                    }

                    {
                        // other than temp, humidity
                        (['leak'].indexOf(threshold.sensor_id) !== -1) &&
                        <div>
                            {
                                <React.Fragment>
                                    <div className='row pb-4'>
                                        <div className='col-md-6 pr-0'>
                                            <span className='d-inline'>If leak detected </span>
                                            <Input onChange={handleInputChange} name='alert_up' autoComplete="off" type='wholeDecimalNumber' value={threshold.alert_up} className='hide form-control d-inline w-75 text-center' fieldname={labels[threshold.sensor_id]} /> {thresholdOptions[threshold.sensor_id]['units']}
                                        </div>
                                    </div>
                                    <div className='row pb-2'>
                                        <div className='col'>
                                            <i htmlFor='notify_me' className={checkboxClassName} value={isNotifyMe} onClick={handleCheckBoxChange}></i>
                                            &nbsp; Notify me only during : {notifyOnDropDown}
                                        </div>
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                    }

                    {
                        // other than temp, humidity
                        (['flow'].indexOf(threshold.sensor_id) !== -1) &&
                        <div>
                            {
                                <React.Fragment>
                                    <div className='row pb-4'>
                                        <div className='col-md-6 pr-0'>
                                            <span className='d-inline'>If flow is more than </span>
                                            <Input onChange={handleInputChange} name='alert_up' autoComplete="off" type='wholeDecimalNumber' value={threshold.alert_up} className='form-control d-inline w-75 text-center' fieldname={labels[threshold.sensor_id]} /> {thresholdOptions[threshold.sensor_id]['units']} per minute
                                        </div>
                                    </div>
                                    <div className='row pb-2'>
                                        <div className='col'>
                                            <i htmlFor='notify_me' className={checkboxClassName} value={isNotifyMe} onClick={handleCheckBoxChange}></i>
                                            &nbsp; Notify me only during : {notifyOnDropDown}
                                        </div>
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                    }

                    {
                        // other than temp, humidity
                        (['battbackup'].indexOf(threshold.sensor_id) !== -1) &&
                        <div>
                            {
                                <React.Fragment>
                                    <div className='row pb-4'>
                                        <div className='col-md-6 pr-0'>
                                            <span className='d-inline'>If battery backup state changes </span>
                                            <Input onChange={handleInputChange} name='alert_up' autoComplete="off" type='wholeDecimalNumber' value={threshold.alert_up} className='hide form-control d-inline w-75 text-center' fieldname={labels[threshold.sensor_id]} /> {thresholdOptions[threshold.sensor_id]['units']}
                                        </div>
                                    </div>
                                    <div className='row pb-2'>
                                        <div className='col'>
                                            <i htmlFor='notify_me' className={checkboxClassName} value={isNotifyMe} onClick={handleCheckBoxChange}></i>
                                            &nbsp; Notify me only during : {notifyOnDropDown}
                                        </div>
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                    }
                </div>
            </div >
        </div >
    );

}

export default Threshold;